/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `index` for the Caintra Connect frontend.
 * @module components/ProposalDetailsView/index
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import React from "react";
import styles from "./index.module.css";
import { useNavigate } from "react-router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ReactComponent as ChevronLeftIcon } from "../../assets/icons/UserViews/ChevronLeftIcon.svg";
import { IconButton } from "@mui/material";

import { useTranslation } from "react-i18next";
import ProposalDetailsContent from "../ProposalDetailsContent";
import { useProposalReview } from "../ProposalDetailsContent/useProposalReview";

const ProposalDetailsView = ({ onBack, proposal, requirement }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const review = useProposalReview({
    proposal,
    navigate,
    onComplete: onBack,
    userId: proposal.idUsuario,
    logProposal: true,
  });

  return (
    <>
      <div className={styles.container}>
        <div className={styles.backNavigation}>
          <IconButton onClick={onBack}>
            <ChevronLeftIcon styles={{}} />
          </IconButton>
          <h2 className={styles.mainTitle}>
            {t("components.proposalDisplayModal.title")}: {requirement?.titulo}
          </h2>
        </div>

        <div className={styles.content}>
          <ProposalDetailsContent
            styles={styles}
            proposal={proposal}
            {...review}
          />
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default ProposalDetailsView;
